import { Config } from '@chegg-wt/core/config'
import { UserRoles } from '@chegg-wt/core/constants/user'
import { GatedStyleRuleTypes } from '@chegg-wt/core/constants/styles'
import { UserRole } from '@chegg-wt/core/types/auth'
import { GatedStyleRuleType, GatedStyleRule } from '../types/styles'

export class UserStyles {
  readonly userRole: UserRole

  private gatedStyleRule: GatedStyleRule | undefined

  private defaultAllowedStyle: string

  constructor(userRole: string) {
    this.userRole = (userRole || UserRoles.NOT_LOGGED_IN) as UserRole
    this.gatedStyleRule = this.getGatedStyleRule()
    this.defaultAllowedStyle = Config.currentStyle
  }

  isStyleAllowed(style: string): boolean {
    return !this.gatedStyleRule || this.gatedStyleRule.allowedStyles.includes(style)
  }

  getGatedStyleRuleType(): GatedStyleRuleType | undefined {
    return this.gatedStyleRule?.type
  }

  private getGatedStyleRule(): GatedStyleRule | undefined {
    return Config.gatedStyleRules.find((rule) => rule.userRoles.includes(this.userRole))
  }

  getDefaultAllowedStyle() {
    return this.defaultAllowedStyle
  }

  isModalGate(): boolean {
    return this.gatedStyleRule?.type === GatedStyleRuleTypes.SOFT_ACCOUNT_GATE
  }
}
